import {customElement, query} from "lit/decorators.js";
import {css, html, LitElement, TemplateResult} from "lit";
import {GameCanvas} from "./GameCanvas";

@customElement("keypad-component")
export class Keypad extends LitElement {
    public static styles = css`
        .keypadWrap {
            background-color: rgba(0, 0, 0, 0.5);
            position: fixed;
            z-index: 200;
            text-align: center;
            display: none;
            justify-content: center;
            align-items: center;
            height: 64vh;
            left: 0;
            width: 100%;
            margin-top: 70px;
        }

        .keypad {
            background-color: #f5f4ef;
            padding: 30px 30px 20px 30px;
        }

        .key {
            font-family: 'onesize';
            width: 50px;
            height: 50px;
            margin: 5px;
            font-size: 20px;
            border: 1px solid #d8d7d5;
            background-color: #b4b5b0;
            cursor: pointer;
        }

        .key:hover {
            background-color: #797979;
        }

        .codeInput {
            width: 150px;
            height: 50px;
            font-size: 30px;
            background-color: #a1af74;
            color: #3c4466;
            border: 3px solid #8f9765;
            border-bottom: 1px solid #fff;
            text-align: center;
            overflow: hidden;
        }

        .alert {
            display: none;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            padding: 10px 20px;
            z-index: 9999;
            min-width: 30%;
            text-align: center;
            font-family: 'onesize';
        }

        .alert h2 {
            margin-bottom: auto;
            font-size: 1.5em;
        }

        .alert p {
            margin-block: 0;
            margin-bottom: 1em;
        }
    `;

    private code: string = "";
    @query("#codeInput")
    private codeInput!: HTMLInputElement;

    public render(): TemplateResult {
        return html`
            <div class="keypadWrap">
                <div class="alert"></div>
                <section class="keypad">
                    <label for="codeInput">
                        <input type="text" class="codeInput" id="codeInput" placeholder="_ _ _" readonly>
                        <br>
                        <br>
                    </label>
                    <section class="row">
                        <button class="key" @click="${(): void => this.addNumber(1)}">1</button>
                        <button class="key" @click="${(): void => this.addNumber(2)}">2</button>
                        <button class="key" @click="${(): void => this.addNumber(3)}">3</button>
                    </section>
                    <section class="row">
                        <button class="key" @click="${(): void => this.addNumber(4)}">4</button>
                        <button class="key" @click="${(): void => this.addNumber(5)}">5</button>
                        <button class="key" @click="${(): void => this.addNumber(6)}">6</button>
                    </section>
                    <section class="row">
                        <button class="key" @click="${(): void => this.addNumber(7)}">7</button>
                        <button class="key" @click="${(): void => this.addNumber(8)}">8</button>
                        <button class="key" @click="${(): void => this.addNumber(9)}">9</button>
                    </section>
                    <section class="row">
                        <button class="key" @click="${this.deleteNumber}">DEL</button>
                        <button class="key" @click="${(): void => this.addNumber(0)}">0</button>
                        <button class="key" @click="${this.checkCode}">OK</button>
                    </section>
                </section>
            </div>
        `;
    }

    private addNumber(number: number): void {
        if (this.code.length < 3) {
            this.code += number;
            this.updateCodeInput();
        }
    }

    private deleteNumber(): void {
        this.code = this.code.slice(0, -1);
        this.updateCodeInput();
    }

    private checkCode(): void {
        const gameCanvas: GameCanvas = document.querySelector<GameCanvas>("game-canvas") as GameCanvas;
        const alert: HTMLElement = this.shadowRoot?.querySelector<HTMLElement>(".alert") as HTMLElement;
        const keypadWrap: HTMLElement = this.shadowRoot?.querySelector<HTMLElement>(".keypadWrap") as HTMLElement;
        alert.style.display = "block";

        if (this.code === "864") {
            alert.style.backgroundColor = "rgba(0, 128, 0, 0.9)";
            alert.innerHTML = "<h2>The correct code has been entered</h2><br><p>The door is now unlocked</p>";
            setTimeout(() => {
                alert.style.display = "none";
                keypadWrap.style.display = "none";
            } , 1500);

            gameCanvas.contentText = ["It appears the code was correct! Now, I can open the hidden door and discover what Emily has been concealing all this time!"];
            gameCanvas.requestUpdate();

        } else if (this.code.length !== 3) {
            alert.style.backgroundColor = "rgba(255, 0, 0, 0.9)";
            alert.innerHTML = "<h2>Please enter a 3-digit code</h2><br><p>Try again.</p>";
            setTimeout(() => alert.style.display = "none", 1500);

        } else if (this.code !== "864") {
            this.code = "";
            this.updateCodeInput();

            alert.style.backgroundColor = "rgba(255, 0, 0, 0.9)";
            alert.innerHTML = "<h2>Incorrect Code.</h2><br><p>Try again.</p>";
            setTimeout(() => alert.style.display = "none", 1500);

        }
    }

    private updateCodeInput(): void {
        this.codeInput.value = "";
        for (let i: number = 0; i < this.code.length; i++) {
            this.codeInput.value += this.code[i];
            if (i !== this.code.length - 1) {
                this.codeInput.value += " ";
            }
        }
        for (let i: number = this.code.length; i < 3; i++) {
            this.codeInput.value += " _";
            if (i !== 2) {
                this.codeInput.value += " ";
            }
        }
    }
}